import React, { useEffect, useState } from "react";
import { Properties } from "../lib/api";
import { Search } from "lucide-react";
import { useNavigate } from "react-router-dom";

const BUDGETS = [
  { value: "any", label: "Any Budget" },
  { value: "under_2cr", label: "Under ₹2 Cr" },
  { value: "2_5cr", label: "₹2 Cr – ₹5 Cr" },
  { value: "5_10cr", label: "₹5 Cr – ₹10 Cr" },
  { value: "above_10cr", label: "Above ₹10 Cr" },
];

export default function SearchBar({ compact = false }) {
  const navigate = useNavigate();
  const [cities, setCities] = useState([]);
  const [city, setCity] = useState("all");
  const [budget, setBudget] = useState("any");

  useEffect(() => {
    Properties.cities().then((d) => setCities(d.cities || [])).catch(() => {});
  }, []);

  const submit = (e) => {
    e.preventDefault();
    const params = new URLSearchParams();
    if (city && city !== "all") params.set("city", city);
    if (budget && budget !== "any") params.set("budget", budget);
    navigate(`/properties?${params.toString()}`);
  };

  return (
    <form
      onSubmit={submit}
      data-testid="hero-search-bar"
      className={`bg-white border border-neutral-200 rounded-2xl shadow-soft p-2 flex flex-col sm:flex-row gap-2 ${compact ? "" : "md:rounded-full"}`}
    >
      <div className="flex-1 px-4 py-2 sm:py-2.5">
        <div className="label-tiny mb-1">City</div>
        <select
          value={city}
          onChange={(e) => setCity(e.target.value)}
          className="w-full text-sm font-medium outline-none bg-transparent cursor-pointer"
          data-testid="search-city-select"
        >
          <option value="all">All Cities</option>
          {cities.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
      </div>
      <div className="hidden sm:block w-px bg-neutral-200" />
      <div className="flex-1 px-4 py-2 sm:py-2.5">
        <div className="label-tiny mb-1">Budget</div>
        <select
          value={budget}
          onChange={(e) => setBudget(e.target.value)}
          className="w-full text-sm font-medium outline-none bg-transparent cursor-pointer"
          data-testid="search-budget-select"
        >
          {BUDGETS.map((b) => <option key={b.value} value={b.value}>{b.label}</option>)}
        </select>
      </div>
      <button
        type="submit"
        className="inline-flex items-center justify-center gap-2 rounded-full bg-brand text-white px-6 py-3 text-sm font-semibold hover:bg-brand-600 transition active:scale-95"
        data-testid="search-submit-btn"
      >
        <Search className="w-4 h-4" /> Search
      </button>
    </form>
  );
}
